import React from 'react';
import { Modal, Text, Button } from '@shopify/polaris';

function SaveModal({ open, onClose, onSave, onDiscard, articleTitle }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Unsaved Changes"
      footer={
        <div style={footerStyle}>
          <Button onClick={onSave} variant="primary" tone="success" style={buttonStyle}>
            Save
          </Button>
          <Button onClick={onDiscard} variant="primary" tone="critical" style={buttonStyle}>
            Discard
          </Button>
          <Button onClick={onClose} style={buttonStyle}>
            Cancel
          </Button>
        </div>
      }
    >
      <Modal.Section>
        <Text as="p">
          If you’ve made any changes in <strong>{articleTitle}</strong>, do you want to save or discard them?
        </Text>
      </Modal.Section>
    </Modal>
  );
}

// Custom styles for responsive footer and buttons, matching default Polaris style
const footerStyle = {
  display: 'flex',
  justifyContent: 'flex-end', // Align buttons to the right as the default
  gap: '10px',
  width: '100%',
  flexDirection: "row", // Allow buttons to wrap on smaller screens
};

const buttonStyle = {
  minWidth: '120px', // Ensure buttons have a minimum width
  width: 'auto',     // Allow buttons to shrink or grow as needed
};

// Add media query for responsiveness
const mediaQuery = `
  @media (max-width: 600px) {
    .Polaris-Button {
      width: 100% !important;  // Make buttons stack on small screens
    }
  }
`;

export default SaveModal;
